import { clamp } from '@ui/style/clamp-calculator';
function remToPx(value) {
    return Math.round(parseFloat(value) * 16);
}
function pxToRem(value) {
    return `${value / 16}rem`;
}
// LEARN MORE
// https://nextjs.org/docs/basic-features/font-optimization#google-fonts
export const typography = {
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemiBold: 600,
    fontWeightBold: 700,
    h1: {
        fontFamily: 'SuisseIntl',
        fontWeight: 500,
        lineHeight: 80 / 64,
        fontSize: clamp.calculate(40, 64)
    },
    h2: {
        fontFamily: 'SuisseIntl',
        fontWeight: 500,
        lineHeight: 64 / 48,
        fontSize: clamp.calculate(32, 48)
    },
    h3: {
        fontFamily: 'SuisseIntl',
        fontWeight: 500,
        lineHeight: 48 / 32,
        fontSize: clamp.calculate(24, 32)
    },
    h4: {
        fontFamily: 'SuisseIntl',
        fontWeight: 500,
        lineHeight: 36 / 24,
        fontSize: clamp.calculate(20, 24)
    },
    h5: {
        fontFamily: 'SuisseIntl',
        fontWeight: 500,
        lineHeight: 30 / 20,
        fontSize: clamp.calculate(18, 20)
    },
    h6: {
        fontFamily: 'ARSMaquettePro',
        fontWeight: 500,
        lineHeight: 28 / 18,
        fontSize: clamp.calculate(16, 18)
    },
    subtitle1: {
        fontFamily: 'SuisseIntl',
        fontWeight: 600,
        lineHeight: 24 / 16,
        fontSize: pxToRem(16)
    },
    subtitle2: {
        fontFamily: 'SuisseIntl',
        fontWeight: 600,
        lineHeight: 22 / 14,
        fontSize: pxToRem(14)
    },
    body1: {
        fontFamily: 'SuisseIntl',
        fontWeight: 400,
        lineHeight: 24 / 16,
        fontSize: pxToRem(16)
    },
    body2: {
        fontFamily: 'SuisseIntl',
        lineHeight: 22 / 14,
        fontSize: pxToRem(14)
    },
    body3: {
        fontFamily: 'SuisseIntl',
        fontWeight: 400,
        lineHeight: 18 / 10,
        fontSize: pxToRem(10)
    },
    caption: {
        fontFamily: 'SuisseIntl',
        fontWeight: 400,
        lineHeight: 18 / 12,
        fontSize: pxToRem(12)
    },
    overline: {
        fontFamily: 'SuisseIntl',
        fontWeight: 700,
        lineHeight: 18 / 12,
        fontSize: pxToRem(12),
        textTransform: 'uppercase'
    },
    button: {
        fontFamily: 'SuisseIntl',
        fontWeight: 500,
        lineHeight: 24 / 14,
        fontSize: pxToRem(14),
        textTransform: 'unset'
    },
    captionOutfit: {
        fontFamily: 'Outfit',
        lineHeight: 18 / 12,
        fontSize: pxToRem(12)
    },
    body2Outfit: {
        fontFamily: 'Outfit',
        lineHeight: 22 / 14,
        fontSize: pxToRem(14)
    },
    subtitle1Outfit: {
        fontFamily: 'Outfit',
        fontWeight: 600,
        lineHeight: 24 / 16,
        fontSize: pxToRem(16)
    }
};
